<template>
	<div class="page-layout" v-loading="loading">
		<gc-header headerData="waterMeterMonitor">
			<template #ops>
				<el-button type="primary" @click="handleExport">导 出</el-button>
			</template>
		</gc-header>
		<div class="content">
			<div class="left">
				<GcRegionTree v-model="form.waterRegionCode" :dataOptions="waterRegionTreeList" />
			</div>
			<div class="run-main">
				<div class="serach">
					<gc-advanced-filter
						ref="advancedFilter"
						v-model="form"
						:fields="filterFields"
						@search="handleFilterSearch"
						@reset="handleFilterReset"
					/>
					<gc-column-setting
						storageKey="localcolumn-water-meter-monitor"
						:columns="columns"
						@update-column="data => (columns = data)"
					></gc-column-setting>
				</div>
				<div class="table-show">
					<gc-table
						:columns="columnList"
						:table-data="tableData"
						:border="true"
						:showPage="true"
						:total="page.total"
						:page-size="page.size"
						:currentPage="page.current"
						@current-page-change="
							currentPage => {
								currentPageChange(currentPage, apiWaterMetrologicalMonitorList)
							}
						"
						@size-change="
							size => {
								page.size = size
								currentPageChange(1, apiWaterMetrologicalMonitorList)
							}
						"
					></gc-table>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { mapActions } from 'vuex'
import common from '../mixins/common'
import { apiWaterMetrologicalMonitorList } from '@/apis/alarm.api'
import { exportReport, apiGetManufacturerList, apiGetBigWatchRegionTree } from '@/apis/statisticAnalysis.api'
import { isBlank } from '@/utils/validate'

export default {
	name: 'waterMeterMonitor',
	mixins: [common],
	data() {
		return {
			form: {
				waterRegionCode: null,
				deviceNo: null,
				designNo: null,
				userNo: null,
				userName: null,
				deviceTypeIdList: null,
				manufacturerId: null,
				address: null,
				phone: null,
				valveStatus: null,
				notUpLoadDay: undefined,
				standard: 0,
			},
			columns: [
				{
					key: 'userNo',
					name: '用户号',
					fixed: 'left',
					tooltip: true,
					dragDisable: true,
					disabledSelect: true,
				},
				{
					key: 'userName',
					name: '客户名称',
					tooltip: true,
				},
				{
					key: 'deviceNo',
					name: '设备通讯编号',
					tooltip: true,
				},
				{
					key: 'designNo',
					name: '外观编号',
					width: 150,
					tooltip: true,
				},
				{
					key: 'address',
					name: '地址',
				},
				{
					key: 'phone',
					name: '手机号',
				},
				{
					key: 'waterRegionName',
					name: '所属区域',
					tooltip: true,
					width: 150,
				},
				{
					key: 'caliber',
					name: '口径',
				},
				{
					key: 'rsrp',
					name: '信号强度',
				},
				{
					key: 'snr',
					name: '信噪比',
				},
				{
					key: 'voltage',
					name: '电池电压（V）',
				},
				{
					key: 'deviceStatusName',
					name: '设备状态',
				},
				{
					key: 'valveStatus',
					name: '阀门状态',
				},
				{
					key: 'curPositiveAccumulation',
					name: '正向累积（m³）',
				},
				{
					key: 'curNegativeAccumulation',
					name: '反向累积（m³）',
				},
				{
					key: 'curTotalFlow',
					name: '综合累积（m³）',
				},
				{
					key: 'temperature',
					name: '温度（℃）',
				},
				{
					key: 'manufacturer',
					name: '厂商',
					tooltip: true,
				},
				{
					key: 'deviceName',
					name: '协议名称',
					tooltip: true,
				},
				{
					key: 'pressure',
					name: '压力（Mpa）',
				},
				{
					key: 'sendSuccessRate',
					name: '通讯成功率',
				},
				{
					key: 'dataTime',
					name: '数据日期',
					minWidth: 180,
				},
			],
			options: {
				valveStatus: [
					{ label: '开启', value: 1 },
					{ label: '关闭', value: 0 },
				],
				standard: [
					{ label: '实际', value: 0 },
					{ label: '取整', value: 1 },
				],
			},
			waterRegionTreeList: [],
		}
	},
	computed: {
		userInfo() {
			return this.$store.getters.userInfo
		},
		columnList() {
			return this.columns.filter(o => o.selected)
		},
		filterFields() {
			return [
				{
					prop: 'deviceNo',
					label: '设备通讯编号',
					type: 'input',
					width: '320px',
				},
				{
					prop: 'designNo',
					label: '外观编号',
					type: 'input',
				},
				{
					prop: 'userNo',
					label: '用户号',
					type: 'input',
				},
				{
					prop: 'userName',
					label: '客户名称',
					type: 'input',
				},
				{
					prop: 'deviceTypeIdList',
					label: '设备类型',
					type: 'select',
					props: {
						searchOption: this.options.deviceTypeId,
						searchOptionKey: {
							label: 'deviceTypeName',
							value: 'deviceTypeId',
						},
						needAllForSearch: true,
						multiple: true,
					},
				},
				{
					prop: 'manufacturerId',
					label: '厂商',
					type: 'select',
					props: {
						searchOption: this.options.manufacturerId,
						needAllForSearch: true,
					},
				},
				{
					prop: 'address',
					label: '地址',
					type: 'input',
				},
				{
					prop: 'phone',
					label: '手机号',
					type: 'input',
				},
				{
					prop: 'valveStatus',
					label: '阀门状态',
					type: 'select',
					props: {
						searchOption: this.options.valveStatus,
						needAllForSearch: true,
					},
				},
				{
					prop: 'notUpLoadDay',
					label: '未上传天数',
					type: 'input-number',
					props: {
						keyWordWidth: '86px',
					},
				},
				{
					prop: 'standard',
					label: '数据类型',
					type: 'select',
					defaultValue: 0,
					props: {
						searchOption: this.options.standard,
					},
				},
			]
		},
	},
	watch: {
		'form.waterRegionCode': {
			handler(val) {
				if (val) {
					this.getList(1, apiWaterMetrologicalMonitorList)
				}
			},
		},
	},

	mounted() {
		this.getRegionTree()
		this.getManufacturerList()
		this.getDeviceTypes().then(res => {
			this.$set(this.options, 'deviceTypeId', res)
		})
		this.getList(1, apiWaterMetrologicalMonitorList)
		const { tenantType, defaultWaterRegionCode } = this.$store.state.user.userInfo
		tenantType == 1 && this.$set(this.form, 'waterRegionCode', defaultWaterRegionCode)
	},

	methods: {
		...mapActions({
			getDeviceTypes: 'common/getAllDeviceTypeList',
		}),
		getRegionTree() {
			apiGetBigWatchRegionTree({ userTypes: [3] }).then(data => {
				this.waterRegionTreeList = this.removeNoDeviceNode(data)
			})
		},
		removeNoDeviceNode(arr) {
			const result = []
			arr.forEach(item => {
				item.disabled = true
				if (item.children && item.children.length > 0) {
					item.children = this.removeNoDeviceNode(item.children)
				}
				if (item.dealFlag == 2) {
					result.push(item)
				}
			})
			return result
		},
		getManufacturerList() {
			apiGetManufacturerList({
				current: 1,
				size: 9999,
				tenantId: this.$store.getters.userInfo.tenantId || undefined,
			}).then(({ records = [] }) => {
				let val = records.map(item => {
					return {
						value: item.manufacturerId,
						label: item.manufacturerName,
					}
				})
				this.$set(this.options, 'manufacturerId', val)
			})
		},

		apiWaterMetrologicalMonitorList,
		handleFilterSearch() {
			this.getList(1, apiWaterMetrologicalMonitorList)
		},
		handleFilterReset() {
			this.getList(1, apiWaterMetrologicalMonitorList)
		},
		handleExport() {
			if (!this.tableData.length) return this.$message.warning('暂无表格数据')
			this.$toast('下载中，请稍后...')
			const params = {}
			for (let key in this.form) {
				if (!isBlank(this.form[key])) {
					params[key] = this.form[key]
				}
			}
			const data = {
				method: 'post',
				url: '/monitor/report/water-measurement-data/export/excel',
				fileName: '计量监控.xlsx',
				data: {
					...params,
					tenantType: this.$store.getters.userInfo.tenantType || '0',
				},
			}
			exportReport(data, 'excel', '', this.$toast)
		},
	},
}
</script>
<style lang="scss" scoped>
@import '../runLayout.scss';
.content {
	flex: 1;
	height: 0;
	display: flex;
	.left {
		width: 300px;
		height: 100%;
		padding: 20px 12px;
		border-right: 1px solid #f1f1f1;
	}
	::v-deep .run-main {
		height: 100%;
		width: 0;
	}
}
</style>
